<template>
    <div :class="('choice-result-progress-bar-' + index) + (percentage <= 38 ? ' choice-result-progress-bar-small' : '')"
         class="choice-result-progress-bar">
        <div :style="{ height: percentage + '%' }" class="result-progress-bar">
            <div class="percentage">{{ percentage }}%</div>
        </div>
        <div class="result-progress-bar-footer">{{ footerText }}</div>
    </div>
</template>

<script>
    export default {
        name: 'result-progress-bar',
        props: {
            index: {
                type: Number,
                required: true
            },
            percentage: {
                type: Number,
            },
            footerText: {
                type: String
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@less/variables.less";

    @footerSize: 40px;

    .choice-result-progress-bar {
        height: 250px;
        position: relative;
        margin-bottom: @footerSize - 5px;

        &.choice-result-progress-bar-0 .result-progress-bar,
        &.choice-result-progress-bar-0 .result-progress-bar-footer {
            background: @choice-color-1;
        }

        &.choice-result-progress-bar-1 .result-progress-bar,
        &.choice-result-progress-bar-1 .result-progress-bar-footer {
            background: @choice-color-2;
        }

        &.choice-result-progress-bar-2 .result-progress-bar,
        &.choice-result-progress-bar-2 .result-progress-bar-footer {
            background: @choice-color-3;
        }

        &.choice-result-progress-bar-3 .result-progress-bar,
        &.choice-result-progress-bar-3 .result-progress-bar-footer {
            background: @choice-color-4;
        }

        .result-progress-bar {
            position: absolute;
            bottom: 5px;
            width: 100%;
            margin-bottom: 10px;
            border-radius: 20px 20px 0 0;

            .percentage {
                font-weight: bold;
                color: white;
                font-size: @app-font-size-result-percentage;
                font-family: "Titillium Web", sans-serif;
                position: absolute;
                top: 20px;
                left: 50%;
                transform: translate(-50%, 0);
                text-shadow: 2px 2px 2px #1C6EA4;
            }
        }

        &.choice-result-progress-bar-small {
            .percentage {
                top: auto;
                bottom: 15px;
            }
        }

        .result-progress-bar-footer {
            width: 100%;
            height: @footerSize;
            border-radius: 5px;

            position: absolute;
            bottom: -@footerSize + 10px;
            color: white;
            line-height: 40px;
            font-size: @app-font-size-result-bar-footer;
            font-weight: bold;
            font-family: 'Titillium Web', sans-serif;
            text-transform: uppercase;
        }
    }
</style>